import React from 'react';
import { HomeSectionEducation } from './_contentSectionEducation';
import { HomeSectionCompetencies } from './_contentSectionCompetencies';
import { HomeSectionExperience } from './_contentSectionExperience';

const HomeContent = props => (
  <div>
    <h1 className='no-print'>Valerii Aligorskii</h1>
    <h2 className={'subtitle profession no-print'}>Full Stack Web Developer</h2>

    <p>
      I am a Software Architect and Development Lead: drive system architecture roadmap and design of enterprise client and server systems. Work with cross-functional teams in full software development life cycle of multiple projects.
    </p>
    <p>Full stack web developer with experience of all level testing, including performance, functional and web application testing.</p>

    <HomeSectionExperience />
    <HomeSectionEducation />
    <HomeSectionCompetencies />
  </div>
);

export default HomeContent;
